import React from "react";
import SingleFormLayout from "./SingleFormLayout";
import EmployeeForm from "../EmployeeManagement/Employees/EmployeesForm";
import EmployeeContactForm from "../EmployeeManagement/EmployeeContactDetails/EmployeeContactForm";
import EmployeeAddressForm from "../EmployeeManagement/EmployeeAddress/EmployeeAddressForm";
import EmployeeEducationForm from "../EmployeeManagement/EmployeeEducation/EmployeeEducationForm";
import { Box } from "@mui/material";
import SubmitButton from "./SubmitButton";
import Header from "./Header";

const sections = [
  {
    id: "profile",
    title: "Employee Details",
    subtitle: "Profile and employment information",
    customComponent: EmployeeForm,
  },
  {
    id: "education",
    title: "Education",
    customComponent: EmployeeEducationForm,
  },
  {
    id: "address",
    title: "Address",
    customComponent: EmployeeAddressForm,
  },
  {
    id: "contact",
    title: "Contact",
    customComponent: EmployeeContactForm,
  },
];

const DynamicFormPage = ({ mode }) => {
  return (
    <Box px={4} py={4}>
      <Header
        mode={mode}
        updateMessage={"Update Employee"}
        addMessage={"Add Employee"}
        homeLink={"/organization/employee/employee-details"}
        homeText={"Employees"}
      />
      <SingleFormLayout sections={sections} mode={mode} />
      <SubmitButton mode={mode} />
    </Box>
  );
};

export default DynamicFormPage;
